import productTileTemplate from '../../sections/collection/productTileTemplateNosto';
import initSelectNewColor from '../../sections/collection/selectNewColor';
import initProductList from '../../sections/product-list';
import { animate } from '../../core/animations';

/*
 Initialize ALL the Nosto recommendation lists available within the page
*/
export default class NostoRecommendationsLists {
  recommendationData; // Original Nosto object of recommendations
  // recommendationDataPage;
  recommendationSections;
  // globalRecommendationSections;
  // pdpRecommendationSections;
  isSimplified;
  hasSwatches;
  hasQuickview;
  eventsInit;

  constructor() {
    this.recommendationData = null;
    // this.globalRecommendationSections = document.querySelectorAll('.product-list--nosto');
    // this.pdpRecommendationSections = document.querySelectorAll('.recommended-products--nosto');
    this.isSimplified = true;
    this.hasSwatches = true;
    this.hasQuickview = false;
    this.eventsInit = false;

    this.recommendationSections = document.querySelectorAll('[data-nosto-recommendations]');
    // this.recommendationSections = [...this.globalRecommendationSections, ...this.pdpRecommendationSections];
  }

  init = () => {
    if (this.recommendationSections.length === 0) {
      return;
    }

    /*
    document.addEventListener('astr-nosto-recommendations-loaded', (e) => {
      console.log(e.detail.message);
      console.log(e.detail.data);

      this.recommendationData = e.detail.data;
      // this.recommendationDataPage = [];

      // this.cleanupData();
      this.populateSections();

      // Send an event to product-list to init the slider using the same code
    });
    */

    this.populateSections();
    this.initEvents();
    initProductList('nosto');
    initSelectNewColor();
    this.selectSwatch();
    animate();
  };

  setRecommendationData = (recommendation_data) => {
    this.recommendationData = recommendation_data;
  };

  initEvents = () => {
    if (this.eventsInit) {
      return;
    }

    this.eventsInit = true;
  };

  /*
  // Not used at the moment but keep it for future reference
  initDynamicSection = (element) => {
    this.recommendationSections = document.querySelectorAll('[data-nosto-recommendations]');
    this.populateSingleSection(element);
    this.initEvents();

    // if (element.id !== window.theme.search.nosto_search_no_results_placement) {
    //   initProductList('nosto');
    // }

    initSelectNewColor();
    this.selectSwatch();
    animate();
  };
  */

  // Select the recommended SKU if any, else, we select the 1st swatch by default
  selectSwatch = (element = null) => {
    const swatch_containers = (element === null) ? document.querySelectorAll('[data-nosto-recommendations] [data-color-swatches]') : element.querySelectorAll('[data-color-swatches]');

    Array.from(swatch_containers).forEach((element) => {
      const recommended_swatch = element.querySelector('[data-color-swatch][data-is-recommended="true"]');
      
      if (recommended_swatch) {
        recommended_swatch.click();
      } else {
        const swatches = element.querySelectorAll('[data-color-swatch]');

        if (swatches.length > 0) {
          swatches[0].click();
        }
      }
    });
  };

  populateSingleSection = (element) => {
    // In some cases like dynamic elements, nosto_element and id are on the same element
    const list_id = element.classList.contains('nosto_element') ? element.id : element.querySelector('.nosto_element').id;

    if (!list_id || typeof this.recommendationData[list_id] === 'undefined') {
      const embeddedParent = element.closest('.recommended-products--embedded');
      const sectionParent = element.closest('.section');
  
      if (embeddedParent) {
        embeddedParent.remove();
      } else if (sectionParent) {
        sectionParent.remove();
      }

      return;
    }

    const nosto_element = element.querySelector('.nosto_element');
    const related_section = element.closest('[data-nosto-recommendations]');

    // Use the Nosto title if setting is enabled
    if (related_section.dataset.useNostoTitle === 'true' || related_section.dataset.useNostoTitle === true) {
      related_section.querySelector('[data-recommendations-title]').textContent = this.recommendationData[list_id].title;
    }

    // Set the result_id for event tracking
    nosto_element.dataset.resultId = this.recommendationData[list_id].result_id || list_id;

    // PDP section
    if (document.querySelector('body').classList.contains('template-product')) {
      this.isSimplified = true;
      this.hasSwatches = false;
      this.hasQuickview = false;
    }

    // PLP section
    if (document.querySelector('body').classList.contains('template-collection')) {
      this.isSimplified = false;
      this.hasSwatches = true;
      this.hasQuickview = true;
    }

    // Moving from Lodash/JSX templates to JavaScript Template Literals
    const products_tiles_html = this.recommendationData[list_id].products.map((product) => productTileTemplate(product, {
      is_slider: true,
      is_simplified: this.isSimplified,
      has_swatches: this.hasSwatches,
      has_quickview: this.hasQuickview,
      is_search: false,
      is_lookbook: false,
      has_animations: false
    })).join('');

    if (products_tiles_html === '') {
      const embeddedParent = element.closest('.recommended-products--embedded');
      const sectionParent = element.closest('.section');

      if (embeddedParent) {
        embeddedParent.remove();
      } else if (sectionParent) {
        sectionParent.remove();
      }
      return;
    }

    if (list_id === window.theme.search.nosto_search_no_results_placement) {
      element.innerHTML = products_tiles_html;
      return;
    }
    
    const left_arrow = element.querySelector('.swiper-button-prev').cloneNode(true);
    const right_arrow = element.querySelector('.swiper-button-next').cloneNode(true);
    nosto_element?.classList.remove('swiper-initialized');

    // element.querySelector('.nosto_element .swiper-wrapper').innerHTML = products_tiles_html;
    nosto_element.innerHTML = `<div class="swiper-wrapper">${products_tiles_html}</div>${left_arrow.outerHTML}${right_arrow.outerHTML}`;

    if (element.closest('.recommended-products--embedded')) {
      element.closest('.recommended-products--embedded').style.display = 'block';
    }
  };

  populateSections = () => {
    Array.from(this.recommendationSections).forEach((element) => {
      this.populateSingleSection(element);
    });
  };
}
